import React, { useEffect, useState } from 'react';
import NousLogo from './NousLogo';

export default function NativeSplash({ onFinish }) {
  const [fadingOut, setFadingOut] = useState(false);

  useEffect(() => {
    // Show splash for 2 seconds, then trigger fade out
    const timer = setTimeout(() => setFadingOut(true), 2000);
    // After fade out animation (500ms), remove from DOM
    const finishTimer = setTimeout(() => onFinish(), 2500);

    return () => {
      clearTimeout(timer);
      clearTimeout(finishTimer);
    };
  }, [onFinish]);

  // Determinar variante del logo basado en la sesión
  const token = localStorage.getItem('token');
  const appMode = localStorage.getItem('appMode');
  let currentVariant = 'metrics'; // Por defecto, la plataforma global
  if (token) {
    currentVariant = appMode === 'coach' ? 'mentor' : 'soma';
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      background: 'var(--bg-dark)',
      zIndex: 99999,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: fadingOut ? 0 : 1,
      transition: 'opacity 0.5s ease-out',
      pointerEvents: 'none'
    }}>
      <div style={{
        animation: 'splashPulse 2s cubic-bezier(0.4, 0, 0.2, 1) infinite',
        transform: 'scale(1.2)'
      }}>
        <NousLogo size="large" showSlogan={false} variant={currentVariant} />
      </div>
      
      <style>{`
        @keyframes splashPulse {
          0%, 100% { opacity: 1; transform: scale(1.2); }
          50% { opacity: 0.6; transform: scale(1.15); }
        }
      `}</style>
    </div>
  );
}
